module.exports = __webpack_public_path__ + "img/durelogo.e9cd1db5.png";